import { FETCH_SITES_START, FETCH_SITES_SUCCESS, FETCH_SITES_ERROR } from '../../actions/admin/sitesActions';

const INIT_STATE = {
    error: "",
    loading: false,
    message: '',
    sites: []
};

const sitesReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case FETCH_SITES_START: {
            return { ...state, error: '', message: '', loading: true };
        }
        case FETCH_SITES_SUCCESS: {
            return { ...state, error: '', message: '', loading: false, sites: action.sites };
        }
        case FETCH_SITES_ERROR: {
            return { ...state, loading: false, error: action.error, message: '' };
        }
        // case SHOW_MESSAGE: {
        //     return {...state, error: '', message: action.payload, loading: false};
        // }
        // case HIDE_MESSAGE: {
        //   return {...state, loading: false, error: '', message: ''};
        // }
        default:
            return state;
    }
}

export default sitesReducer;
